import { render, staticRenderFns } from "./CreateTurn.vue?vue&type=template&id=c0ec4432&"
import script from "./CreateTurn.vue?vue&type=script&lang=js&"
export * from "./CreateTurn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports